import facultyWorkloadService from "../../apiServices/faculty/facultyWorkloadService";
import { setWorkload } from "../../store/slices/faculty/facultyWorkloadSlice";

export function getWorkload() {
  return async function (dispatch: any, getState: any) {
    let response = await facultyWorkloadService.getWorkload()
    if (response?.success === true) {
      dispatch(setWorkload(response.data));
    } else {
      console.log("error");
    }
  };
}